export default __webpack_public_path__ + "static/media/seal-of-utah.57e1e4bb.png";